import React from 'react';
import styles from '../event.scss';
import config from '../../../../config';

const EventRegionWarningPopup = ({ onCloseClick, onContinueClick, regions, ...props }) => {
    const regionsList = regions?.length ? `${regions.map(r => r.regionName).join(', ')} ${regions.length > 1 ? 'regions' : 'region'}` : '';
    return (
        <div className={styles.popup} data-testid="modal.event-region-warning">
            <div
                className={`${styles.popup_inner}`}
                style={props.topPoint ? { top: props.topPoint.toString(), transform: `translateX(-50%) translateY(-50%)` } : {}}
            >
                <div className={styles.gradientBar} />
                <div className={`${styles.popupContent}`}>
                    <p>National Pathway events only allow players within the region of the host site to register for the events. Each region has equal events for players within their region.</p>
                    <p>This event is outside of your region and restricted to players in the <b>{regionsList}</b>.</p>
                    <p>To view your region please visit your profile page and select &quot;edit profile.&quot; If you believe your profile is designated to the incorrect region, please <a href={`https://support.${config.siteBaseUrl}/support/tickets/new`} target="_blank" rel="noopener noreferrer" data-testid="modal.event-region-warning.contact-link">contact us</a>.</p>
                </div>
                <div className={`text-right ${styles.popupFooter}`}>
                    <button
                        type="button"
                        className={`btn btn-default btn-sm text-uppercase`}
                        onClick={onCloseClick}
                        data-testid="modal.event-region-warning.close-btn"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        className={`btn btn-primary btn-sm text-uppercase`}
                        onClick={onContinueClick}
                        data-testid="modal.event-region-warning.continue-btn"
                    >
                        Continue to Profile
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EventRegionWarningPopup;
